import { useEffect } from "react";
import { ReactComponentProps, navigate } from "@reach/router";

const ExternalRedirect = ({ to }: ReactComponentProps) => {
	useEffect(() => {
		window.open(to, "_blank");
		navigate("/account/rfx");
	}, [to]);

	return null;
};

export default ExternalRedirect;
